<template>
<div>
    <!-- modal -->
    <b-modal id="clientFormModal" ref="clientFormModal" centered size="xl" no-close-on-backdrop :title=" $t('client.info')" hide-footer @hide="onClientModalHide">
        <reminder-form ref="reminderForm"></reminder-form>
        <client-merge-company-form ref="clientMergeCompanyFormModal"></client-merge-company-form>
        <mail-send-form ref="mailSendFormModal"></mail-send-form>
        <b-card>
            <validation-observer ref="simpleRules">
                <div class="custom-search d-flex justify-content-end">
                    <b-col class="col-lg-8">
                        <b-form>
                            <label for="client-name-input">{{ $t('client.name') }}</label>
                            <b-form-group>
                                <validation-provider #default="{ errors }" :name=" $t('client.name')" rules="required">
                                    <b-form-input size="sm" id="client-name-input" v-model="clientName" maxlength="250" :state="errors.length > 0 ? false:null" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-4 mt-2" style="text-align: right;">
                        <b-button variant="outline-primary" size="sm" class="mr-1" @click.prevent="addOrUpdate">
                            {{$t('others.ok_title')}}
                        </b-button>
                        <b-dropdown style="width: 4em; height: 2em;" id="dropdown-grouped" variant="outline-primary" right class="dropdown-icon-wrapper" size="sm">
                            <template #button-content>
                                <feather-icon icon="MailIcon" size="10" class="align-middle" />
                            </template>
                            <b-dropdown-item @click="prepareClientMail(mailTemplate.id)" v-for="mailTemplate in mailTemplateList" :key="mailTemplate.id">
                                <span>{{mailTemplate.explanation}}</span>
                            </b-dropdown-item>
                        </b-dropdown>
                        <b-button variant="outline-primary" class="ml-1" size="sm" v-b-tooltip.html :title="$t('others.reminder')" @click="getReminderInfo()">
                            <feather-icon icon="BellIcon" size="10" class="align-middle" />
                        </b-button>
                        <b-button :hidden="hiddenClientControl" variant="outline-primary" v-b-tooltip.html :title="$t('others.merge_company')" size="sm" class="btn-icon ml-1" @click="mergeCompany(0)">
                            <feather-icon icon="GitMergeIcon" />
                        </b-button>
                        <client-merge-company-form :getClientList="getClientList" :clientId="this.id"></client-merge-company-form>
                        <mail-send-form :getClientList="getClientList" :clientId="this.id"></mail-send-form>
                    </b-col>
                </div>
            </validation-observer>
        </b-card>
        <b-card :hidden="hiddenClientControl">
            <b-tabs>
                <!-- Agent Information -->
                <b-col class="custom-tabs">
                    <b-tab :title="$t('client.agent_information')">
                        <b-tabs active vertical>
                            <b-tab :title=" $t('client.address')" active style="width:100%;">
                                <b-card-text class="tabs-custom-css">
                                    <client-address-list ref="clientAddressList" :clientId="this.id"></client-address-list>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title=" $t('client.contact')" style="width:100%;">
                                <b-card-text class="tabs-custom-css">
                                    <client-contact-list :clientId="this.id"></client-contact-list>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title=" $t('client.responsible')" style="width:100%;">
                                <b-card-text class="tabs-custom-css">
                                    <client-responsible-list ref="clienResponsibleList" :clientId="this.id"></client-responsible-list>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title=" $t('client.liable')" style="width:100%;">
                                <b-card-text class="tabs-custom-css">
                                    <client-liable-list :clientId="this.id"></client-liable-list>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title=" $t('client.history')" style="width:100%;">
                                <b-card-text class="tabs-custom-css">
                                    <client-history-list ref="clientHistoryList" :clientId="this.id"></client-history-list>
                                </b-card-text>
                            </b-tab>
                        </b-tabs>
                    </b-tab>
                </b-col>
                <!-- Accounting Information -->
                <b-col class="custom-tabs">
                    <b-tab :title=" $t('client.accounting_information')">
                        <b-tabs vertical>
                            <b-tab :title=" $t('client.accounting')" style="width:100%;">
                                <b-card-text class="tabs-custom-css">
                                    <client-accounting-list ref="clientAccountingList" :getClientList="getClientList" :clientId="this.id"></client-accounting-list>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title=" $t('client.dailywork')" style="width:100%;">
                                <b-card-text class="tabs-custom-css">
                                    <dailywork-list :recordId="this.id" :moduleId="1"></dailywork-list>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title=" $t('client.invoices')" style="width:100%;">
                                <b-card-text class="tabs-custom-css">
                                    <client-invoices-list :clientId="this.id"></client-invoices-list>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title=" $t('client.ledes_folders')" style="width:100%;">
                                <b-card-text class="tabs-custom-css">
                                    <ledes-folders-list :clientId="this.id"></ledes-folders-list>
                                </b-card-text>
                            </b-tab>
                        </b-tabs>
                    </b-tab>
                </b-col>
                <!-- Records -->
                <b-col class="custom-tabs">
                    <b-tab :title="$t('client.records')">
                        <b-tabs vertical>
                            <b-tab :title="$t('client.notes')" style="width:100%;">
                                <b-card-text class="tabs-custom-css">
                                    <client-note-list :clientId="this.id"></client-note-list>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title=" $t('client.digital_archive')" style="width:100%;">
                                <b-card-text class="tabs-custom-css">
                                    <documents-list :recordId="this.id" :moduleId="1"></documents-list>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title=" $t('client.folders')" style="width:100%;">
                                <b-card-text class="tabs-custom-css">
                                    <client-folder-list :clientOwnershipInfo="clientOwnershipInfo" :ownerControl="false" :agentControl="true" :clientId="this.id" :getClientList="getClientList"></client-folder-list>
                                </b-card-text>
                            </b-tab>
                        </b-tabs>
                    </b-tab>
                </b-col>
                <!-- Reminder Selections -->
                <b-col class="custom-tabs">
                    <b-tab :title=" $t('client.reminder_selections')">
                        <b-tabs vertical>
                            <b-card class="tabs-custom-css">
                                <b-alert variant="primary" show>
                                    <div class="alert-body">
                                        <span>
                                            <b-form-checkbox v-model="working" name="checkbox">
                                                {{ $t('client.working') }}
                                            </b-form-checkbox>
                                        </span>
                                    </div>
                                </b-alert>
                                <b-alert variant="primary" show>
                                    <div class="alert-body">
                                        <span>
                                            <b-form-checkbox v-model="annuity" name="checkbox">
                                                {{ $t('client.annuity') }}
                                            </b-form-checkbox>
                                        </span>
                                    </div>
                                </b-alert>
                                <b-alert variant="primary" show>
                                    <div class="alert-body">
                                        <span>
                                            <b-form-checkbox v-model="compensationFee" name="checkbox">
                                                {{ $t('client.compensation_fee') }}
                                            </b-form-checkbox>
                                        </span>
                                    </div>
                                </b-alert>
                                <b-alert variant="primary" show>
                                    <div class="alert-body">
                                        <span>
                                            <b-form-checkbox v-model="patentCertificate" name="checkbox">
                                                {{ $t('client.patent_certificate') }}
                                            </b-form-checkbox>
                                        </span>
                                    </div>
                                </b-alert>
                            </b-card>
                        </b-tabs>
                    </b-tab>
                </b-col>
                <!-- Visit -->
                <b-col class="custom-tabs">
                    <b-tab :title="$t('client.visit')">
                        <b-tabs vertical>
                            <b-card-text class="tabs-custom-css">
                                <client-visit-list :clientId="this.id"></client-visit-list>
                            </b-card-text>
                        </b-tabs>
                    </b-tab>
                </b-col>
            </b-tabs>
        </b-card>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getClientList: {
            type: Function
        }
    },
    data() {
        return {
            id: 0,
            clientName: '',
            sectorSelect: 0,
            sectorOption: [],
            ownerCode: null,
            hiddenClientControl: true,
            collapseType: 'margin',
            ownerCodeOptions: {
                blocks: [6],
                numericOnly: true
            },
            mailTemplateList: [],
            selected: null,
            working: false,
            annuity: false,
            compensationFee: false,
            patentCertificate: false,
            clientOwnershipInfo: {},
            clientAccountingInformation: {},
            forceClose: false
        }
    },
    methods: {
        async onClientModalHide(evt) {
            if (this.forceClose) {
                this.forceClose = false
                return
            }
            const addressCount = this.$refs.clientAddressList.rows;

            if (this.id > 0 && addressCount.length == 0) {
                evt.preventDefault();
                this.$PrivateConfirm(this.$t("others.client_auth_address_title"), this.$t("others.client_auth_address_message"), "warning", this.$t("others.client_auth_confirm_button"), this.$t("others.client_auth_cancel_button"))
                    .then(result => {
                        if (result.value) {
                            this.forceClose = true
                            this.$bvModal.hide('clientFormModal')
                        }
                    });
            } else if (this.id > 0) {
                const accountingCount = this.$refs.clientAccountingList.rows;
                if (accountingCount.length == 0 && accountingCount.length == 0) {
                    evt.preventDefault();
                    this.$PrivateConfirm(this.$t("others.client_auth_accounting_title"), this.$t("others.client_auth_accounting_message"), "warning", this.$t("others.client_auth_confirm_button"), this.$t("others.client_auth_cancel_button"))
                        .then(result => {
                            if (result.value) {
                                this.forceClose = true
                                this.$bvModal.hide('clientFormModal')
                            }
                        });
                } else if (this.id > 0) {
                    const responsibleCount = this.$refs.clienResponsibleList.rows;
                    if (responsibleCount.length == 0) {
                        evt.preventDefault();
                        this.$PrivateConfirm(this.$t("others.client_responsible_title"), this.$t("others.client_responsible_message"), "warning", this.$t("others.client_auth_confirm_button"), this.$t("others.client_auth_cancel_button"))
                            .then(result => {
                                if (result.value) {
                                    this.forceClose = true
                                    this.$bvModal.hide('clientFormModal')
                                }
                            });
                    }
                }
            }

        },
        async mergeCompany() {
            this.$refs.clientMergeCompanyFormModal.showInfo(0)
        },
        //async getInfoMail() {
        //    this.$refs.mailSendFormModal.showInfo(0)
        //},
        async getReminderInfo() {
            this.$refs.reminderForm.showInfo(0, this.id, 1)
        },
        showInfo(id) {
            this.$refs['clientFormModal'].show()
            this.id = id

            if (this.id == 0) {
                this.hiddenClientControl = true
            } else {
                this.hiddenClientControl = false
            }

            const data = {
                id: this.id
            }
            const controller = {
                name: 'Client'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.clientId = response.data.client.id
                    this.mailTemplateList = response.data.mailTemplateList
                    this.clientName = response.data.client.name
                    this.sectorSelect = response.data.client.sectorId
                    this.sectorOption = response.data.sectorList
                    this.ownerCode = response.data.client.ownerCode
                    this.clientOwnershipInfo = response.data.clientOwnershipInformation
                    this.clientAccountingInformation = response.data.clientAccountingInformation
                    this.sectorOption.splice(0, 0, this.$nullSelected('nameTR'))
                    const reminderData = {
                        id: this.clientId
                    }
                    const controllerData = {
                        name: "ClientReminderOptions",
                        actionName: "GetClientReminderOptionsInfoByClientId"
                    }
                    const payload = {
                        data: reminderData,
                        controller: controllerData
                    }
                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.working = response.data.clientReminderOptions.working
                            this.annuity = response.data.clientReminderOptions.annuity
                            this.compensationFee = response.data.clientReminderOptions.compensationFee
                            this.patentCertificate = response.data.clientReminderOptions.patentCertificate
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                } else {
                    this.$bvModal.hide('clientFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        downloadClientWordFile(documentId, name) {
            const data = {
                moduleId: 1,
                documentId: documentId,
                clientId: this.id
            }
            const controller = {
                name: 'Client',
                actionName: 'DownloadClientWordFile'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile(name + '-' + this.clientName, response.data.base64, 'docx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        prepareClientMail(mailTemplateId) {
            const data = {
                mailTemplateId: mailTemplateId,
                clientId: this.id
            }
            const controller = {
                name: 'Client',
                actionName: 'PrepareClientMail'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$refs.mailSendFormModal.showInfo(response.data)
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                name: this.clientName,
                isAgent: true,
                isOwner: false,
                ownerCode: this.ownerCode,
                sectorId: this.sectorSelect
            }
            const controller = {
                name: 'Client'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            if (this.id == 0) {
                                this.id = response.data.clientId
                                this.working = true
                                this.annuity = true
                                this.patentCertificate = true
                                this.compensationFee = true
                            }
                            const data1 = {
                                clientId: this.id,
                                working: this.working,
                                annuity: this.annuity,
                                patentCertificate: this.patentCertificate,
                                compensationFee: this.compensationFee
                            }
                            const controller1 = {
                                name: 'ClientReminderOptions'
                            }
                            const payload = {
                                data: data1,
                                controller: controller1
                            }
                            this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                                if (response.data.resultStatus == true) {
                                    if (this.getClientList != null) {
                                        this.getClientList()
                                    }
                                    this.$SaveAlert()
                                    this.$refs.clientHistoryList.getClientHistoryList()
                                } else {
                                    this.$WarningAlert(response.data.resultMessage)
                                }
                            })

                            this.hiddenClientControl = false

                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

[dir] .dark-layout .modal .modal-content,
[dir] .dark-layout .modal .modal-body,
[dir] .dark-layout .modal .modal-footer {
    background-color: #272e3f !important;
    border-color: #3b4253;
}

[dir] .vs__selected-options {
    padding: 0 2px;
    font-size: 0.9em;
}

.tabs-custom-css {
    width: auto;
}

.custom-tabs {
    width: 100% !important;
}
</style>
